import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReduxSpecialist from '../../../../store/actionreducers/specialist';
import {withRouter} from 'react-router-dom';
import ReactTable from "react-table";
import moment from 'moment'

// This Component is view to show all work events for the specialist

class SpecialistCalendarApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            timeTables: [],
        };
    }

    async componentDidMount() {
        let timeTables = []
        const { getAvailableWorkTime, user, getAvailableWorkTimeByAdminMedical } = this.props

        const params = {
            division: null,
            medical: null,
            from: moment().format('YYYY-MM-DD'),
            to: null,
            past: true
        }

        const workTimes = (user && user.role === 'adminMedical')
            ? await getAvailableWorkTimeByAdminMedical(params)
            : await getAvailableWorkTime(params)

        /*
        Loop through all worktimes and structure the work times by rows of
        - from, the session time from
        - to, the session time to
        - date, the work date
        - medical, name of the medical
        - institution, name of the institution
        - division, name of the division
        - department, name of the department

        The data would be aggregated to timeTables: object[]
         */

        if (workTimes && workTimes.timePeriods){
            workTimes.timePeriods.forEach((timePeriod) => {
                if (timePeriod && timePeriod.periods) {
                    timePeriod.periods.forEach((period) => {
                        if (period && period.workEvents){
                            period.workEvents.forEach((workEvent) => {
                                const medicalName = workTimes.medicals[workEvent.medicalId].name.lastName +
                                                    workTimes.medicals[workEvent.medicalId].name.firstName
                                const institutionName = (workTimes.medicals[workEvent.medicalId].institution) ?
                                                        (workTimes.medicals[workEvent.medicalId].institution.name) : ''
                                const divisionName = workTimes.medicals[workEvent.medicalId].division.name
                                const departmentName = workTimes.medicals[workEvent.medicalId].division.department.name
                                timeTables.push({
                                    from: timePeriod.range.from,
                                    to: timePeriod.range.to,
                                    date: workEvent.date,
                                    medical: medicalName,
                                    institution: institutionName,
                                    division: divisionName,
                                    department: departmentName
                                })
                            })
                        }
                    })
                }
            })
        }

        timeTables = timeTables.filter((workTime, index, self) =>
            index === self.findIndex((t) => (
                t.date === workTime.date && t.medical === workTime.medical && t.from === workTime.from
            ))
        )
        this.setState({timeTables})
    }

    render() {
        const { timeTables } = this.state;
        // The render part is simple, just embeded the data to a react table
        return (
            <div>
                <h1 className={'p-12'}>專科醫師排班表</h1>
                <ReactTable
                    data={timeTables}
                    columns={[
                        {
                            Header: "科系",
                            accessor: "department",
                            filterable: false,
                            className: "font-bold justify-center",
                            width: 96,
                        },
                        {
                            Header: "科別",
                            accessor: "division",
                            filterable: false,
                            className: "font-bold justify-center",
                            width: 96,
                        },
                        {
                            Header: "所屬醫院",
                            accessor: "institution",
                            filterable: false,
                            className: "font-bold justify-center",
                            width: 192,
                        },
                        {
                            Header: "醫師姓名",
                            accessor: "medical",
                            filterable: false,
                            className: "font-bold justify-center",
                            width: 96,
                        }, {
                            Header: "排班日期",
                            accessor: "date",
                            filterable: false,
                            className: "font-bold justify-center",
                            width: 96,
                        },
                        {
                            Header: "起",
                            accessor: "from",
                            filterable: false,
                            width: 96,
                            className: "justify-center",
                        },
                        {
                            Header: "至",
                            accessor: "to",
                            filterable: false,
                            className: "justify-center",
                            width: 96,
                        },
                    ]}
                    initialState={{ sortBy: [{ id: 'date', desc: false }] }}
                />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAvailableWorkTime: ReduxSpecialist.ActionCreator.getAvailableWorkTime,
        getAvailableWorkTimeByAdminMedical: ReduxSpecialist.ActionCreator.getAvailableWorkTimeByAdminMedical,
    }, dispatch);
}

function mapStateToProps({ auth: { user }}) {
    return { user };
}

export default (withRouter(connect(mapStateToProps, mapDispatchToProps)(SpecialistCalendarApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/SpecialistCalendarApp.js